/**
 * Generated by orval v7.17.0 🍺
 * Do not edit manually.
 * FieldPay API
 * FieldPay API for managing organizations, opportunities, payouts and talent management
 * OpenAPI spec version: v1
 */
import * as zod from 'zod';


/**
 * **Required Permission(s):** ORG_FUNDING_GET
 */
export const getApiAdminFundingStatusResponse = zod.object({
  "identityVerification": zod.object({
  "status": zod.enum(['NotStarted', 'Pending', 'UnderReview', 'Approved', 'Rejected', 'Suspended']),
  "hasCredential": zod.boolean(),
  "hasBusinessProfile": zod.boolean(),
  "hasCompleted": zod.boolean(),
  "isReadyForFunding": zod.boolean(),
  "canReauthorize": zod.boolean(),
  "requiresReverification": zod.boolean()
}),
  "hasLinkedAccount": zod.boolean(),
  "balance": zod.number(),
  "pendingDeposits": zod.number(),
  "projectedBalance": zod.number(),
  "lowBalanceThreshold": zod.number(),
  "lowBalanceWarningWarranted": zod.boolean(),
  "targetBalance": zod.number()
})

/**
 * **Required Permission(s):** ORG_FUNDING_GET
 */
export const getApiAdminFundingBalanceResponse = zod.object({
  "availableBalance": zod.number(),
  "pendingDeposits": zod.number()
})

/**
 * **Required Permission(s):** ORG_FUNDING_VERIFY_BUSINESS
 */
export const postApiAdminFundingInitiateIdentityVerificationBody = zod.object({
  "phone": zod.string(),
  "businessName": zod.string(),
  "businessType": zod.enum(['SoleProprietorship', 'Corporation', 'Llc', 'Nonprofit', 'Partnership']),
  "address1": zod.string(),
  "city": zod.string(),
  "state": zod.string(),
  "postalCode": zod.string(),
  "ein": zod.string().nullish(),
  "doingBusinessAs": zod.string().nullish(),
  "businessPhone": zod.string().nullish(),
  "address2": zod.string().nullish(),
  "website": zod.string().nullish(),
  "businessClassification": zod.string().nullish(),
  "industryClassification": zod.string().nullish(),
  "adminFirstName": zod.string(),
  "adminLastName": zod.string(),
  "adminEmail": zod.string(),
  "adminDateOfBirth": zod.string().nullish(),
  "adminSsn": zod.string().nullish(),
  "adminAddress1": zod.string().nullish(),
  "adminCity": zod.string().nullish(),
  "adminState": zod.string().nullish(),
  "adminPostalCode": zod.string().nullish(),
  "controllerFirstName": zod.string().nullish(),
  "controllerLastName": zod.string().nullish(),
  "controllerEmail": zod.string().nullish(),
  "controllerTitle": zod.string().nullish(),
  "controllerDateOfBirth": zod.string().nullish(),
  "controllerSsn": zod.string().nullish(),
  "controllerAddress1": zod.string().nullish(),
  "controllerAddress2": zod.string().nullish(),
  "controllerCity": zod.string().nullish(),
  "controllerState": zod.string().nullish(),
  "controllerPostalCode": zod.string().nullish(),
  "beneficialOwners": zod.array(zod.object({
  "email": zod.string(),
  "firstName": zod.string(),
  "lastName": zod.string(),
  "dateOfBirth": zod.string(),
  "ssn": zod.string(),
  "address1": zod.string(),
  "address2": zod.string().nullish(),
  "city": zod.string(),
  "state": zod.string(),
  "postalCode": zod.string()
}))
})

export const postApiAdminFundingInitiateIdentityVerificationResponse = zod.object({
  "verificationUrl": zod.string()
})

/**
 * **Required Permission(s):** ORG_FUNDING_VERIFY_BUSINESS
 */
export const getApiAdminFundingAuthorizationUrlResponse = zod.object({
  "verificationUrl": zod.string()
})

/**
 * **Required Permission(s):** ORG_FUNDING_VERIFY_BUSINESS
 */
export const postApiAdminFundingCompleteIdentityVerificationBody = zod.object({
  "authorizationCode": zod.string().nullish(),
  "userIntentId": zod.string().nullish()
})

/**
 * **Required Permission(s):** ORG_BANK_ACCOUNT_CREATE
 */
export const postApiAdminFundingLinkTokenResponse = zod.object({
  "linkToken": zod.string(),
  "expiration": zod.string()
})

/**
 * **Required Permission(s):** ORG_BANK_ACCOUNT_CREATE
 */
export const postApiAdminFundingLinkAccountBody = zod.object({
  "publicToken": zod.string(),
  "accountIds": zod.array(zod.string()),
  "institutionId": zod.string(),
  "institutionName": zod.string()
})

export const postApiAdminFundingLinkAccountResponseItem = zod.object({
  "accountId": zod.string(),
  "institutionName": zod.string(),
  "accountMask": zod.string(),
  "accountType": zod.string()
})
export const postApiAdminFundingLinkAccountResponse = zod.array(postApiAdminFundingLinkAccountResponseItem)

/**
 * **Required Permission(s):** ORG_BANK_ACCOUNT_LIST
 */
export const getApiAdminFundingAccountsResponseItem = zod.object({
  "id": zod.string(),
  "institutionName": zod.string(),
  "institutionLogo": zod.string().nullish(),
  "accountName": zod.string(),
  "accountMask": zod.string(),
  "accountType": zod.string(),
  "isFundingSource": zod.boolean(),
  "isPaymentDestination": zod.boolean(),
  "status": zod.string(),
  "isRealTimePaymentEnabled": zod.boolean().nullish(),
  "nickname": zod.string().nullish(),
  "createdDate": zod.string()
})
export const getApiAdminFundingAccountsResponse = zod.array(getApiAdminFundingAccountsResponseItem)

/**
 * **Required Permission(s):** ORG_BANK_ACCOUNT_UPDATE
 */
export const putApiAdminFundingAccountsAccountIdFundingSourceParams = zod.object({
  "accountId": zod.string().uuid()
})

/**
 * **Required Permission(s):** ORG_BANK_ACCOUNT_UPDATE
 */
export const putApiAdminFundingAccountsAccountIdPaymentDestinationParams = zod.object({
  "accountId": zod.string().uuid()
})

/**
 * **Required Permission(s):** ORG_BANK_ACCOUNT_UPDATE
 */
export const putApiAdminFundingAccountsReorderBody = zod.object({
  "accountIds": zod.array(zod.string().uuid())
})

/**
 * **Required Permission(s):** ORG_BANK_ACCOUNT_UPDATE
 */
export const patchApiAdminFundingAccountsAccountIdNicknameParams = zod.object({
  "accountId": zod.string().uuid()
})

export const patchApiAdminFundingAccountsAccountIdNicknameBody = zod.object({
  "nickname": zod.string().nullish()
})

/**
 * **Required Permission(s):** ORG_BANK_ACCOUNT_DELETE
 */
export const deleteApiAdminFundingAccountsAccountIdParams = zod.object({
  "accountId": zod.string().uuid()
})

/**
 * **Required Permission(s):** ORG_FUNDING_GET
 */
export const partitionDepositsQueryParams = zod.object({
  "amount": zod.number().optional(),
  "initiationDate": zod.string().date().optional()
})

export const partitionDepositsResponse = zod.object({
  "totalAmount": zod.number(),
  "deposits": zod.array(zod.object({
  "amount": zod.number(),
  "initiationDay": zod.string().date()
}))
})

/**
 * **Required Permission(s):** ORG_FUNDING_CREATE
 */
export const createDepositPlanBody = zod.object({
  "sourceAccountId": zod.string().uuid(),
  "amount": zod.number(),
  "initiationDate": zod.string().date()
})

export const createDepositPlanResponse = zod.object({
  "id": zod.string().uuid(),
  "totalAmount": zod.number(),
  "depositContext": zod.enum(['Funding', 'AutoTopUp', 'Adjustment', 'Recurring', 'JustInTime']),
  "plannedFor": zod.string().date().nullish(),
  "cappedAt": zod.string().datetime({}).nullish(),
  "createdDate": zod.string().datetime({}),
  "deposits": zod.array(zod.object({
  "id": zod.string().uuid(),
  "amount": zod.number(),
  "initiationDate": zod.string().datetime({}),
  "status": zod.enum(['Scheduled', 'Pending', 'Unconfirmed', 'Processing', 'Settled', 'Failed', 'Returned', 'Canceled', 'Aborted']),
  "createdDate": zod.string().datetime({})
}))
})

/**
 * **Required Permission(s):** ORG_FUNDING_GET
 */
export const getApiAdminFundingTransactionsQueryLimitDefault = 50;

export const getApiAdminFundingTransactionsQueryParams = zod.object({
  "limit": zod.number().default(getApiAdminFundingTransactionsQueryLimitDefault)
})

export const getApiAdminFundingTransactionsResponseItem = zod.object({
  "id": zod.string(),
  "amount": zod.number(),
  "type": zod.string(),
  "status": zod.string(),
  "createdDate": zod.string(),
  "canceledAt": zod.string().nullish(),
  "canceledBy": zod.string().nullish(),
  "abortReason": zod.string().nullish()
})
export const getApiAdminFundingTransactionsResponse = zod.array(getApiAdminFundingTransactionsResponseItem)

/**
 * **Required Permission(s):** ORG_FUNDING_GET
 */
export const getCashflowQueryParams = zod.object({
  "from": zod.string().date().optional(),
  "to": zod.string().date().optional()
})

export const getCashflowResponseItem = zod.object({
  "day": zod.string().date(),
  "moneyIn": zod.number(),
  "moneyOut": zod.number(),
  "projectedBalance": zod.number(),
  "movements": zod.array(zod.object({
  "amount": zod.number(),
  "kind": zod.enum(['Deposit', 'ScheduledDeposit', 'ProjectedDeposit', 'SkippedDeposit', 'Adjustment', 'Payment']),
  "sourceAccountInstitutionName": zod.string().nullish(),
  "sourceAccountMask": zod.string().nullish(),
  "payeeName": zod.string().nullish()
})),
  "obligations": zod.array(zod.object({
  "releaseDay": zod.string().date(),
  "amountOwed": zod.number(),
  "isReleased": zod.boolean(),
  "payeeName": zod.string()
}))
})
export const getCashflowResponse = zod.array(getCashflowResponseItem)

/**
 * **Required Permission(s):** ORG_FUNDING_GET
 */
export const listShortfallsResponseItem = zod.object({
  "releaseDay": zod.string().date(),
  "amountOwed": zod.number(),
  "projectedBalance": zod.number(),
  "amountShort": zod.number(),
  "isOverdue": zod.boolean(),
  "depositDay": zod.string().date()
})
export const listShortfallsResponse = zod.array(listShortfallsResponseItem)

/**
 * **Required Permission(s):** ORG_FUNDING_GET
 */
export const listScheduledDepositsResponseItem = zod.object({
  "id": zod.string().uuid(),
  "amount": zod.number(),
  "initiationDate": zod.string().datetime({}),
  "depositContext": zod.enum(['Funding', 'AutoTopUp', 'Adjustment', 'Recurring', 'JustInTime']),
  "sourceAccountId": zod.string().uuid(),
  "sourceAccountInstitutionName": zod.string().nullish(),
  "sourceAccountMask": zod.string().nullish(),
  "sourceAccountDisplayType": zod.string().nullish(),
  "createdDate": zod.string().datetime({})
})
export const listScheduledDepositsResponse = zod.array(listScheduledDepositsResponseItem)

/**
 * **Required Permission(s):** ORG_FUNDING_CREATE
 */
export const rescheduleDepositParams = zod.object({
  "id": zod.string().uuid()
})

export const rescheduleDepositBody = zod.object({
  "amount": zod.number(),
  "initiationDate": zod.string().date()
})

export const rescheduleDepositResponse = zod.object({
  "id": zod.string().uuid(),
  "amount": zod.number(),
  "initiationDate": zod.string().datetime({}),
  "depositContext": zod.enum(['Funding', 'AutoTopUp', 'Adjustment', 'Recurring', 'JustInTime']),
  "sourceAccountId": zod.string().uuid(),
  "sourceAccountInstitutionName": zod.string().nullish(),
  "sourceAccountMask": zod.string().nullish(),
  "sourceAccountDisplayType": zod.string().nullish(),
  "createdDate": zod.string().datetime({})
})

/**
 * **Required Permission(s):** ORG_FUNDING_CREATE
 */
export const initiateScheduledDepositNowParams = zod.object({
  "id": zod.string().uuid()
})

/**
 * **Required Permission(s):** ORG_FUNDING_CREATE
 */
export const cancelScheduledDepositParams = zod.object({
  "id": zod.string().uuid()
})

/**
 * **Required Permission(s):** ORG_FUNDING_GET
 */
export const listSkippedDepositsResponseItem = zod.object({
  "depositPlanId": zod.string().uuid(),
  "amount": zod.number(),
  "plannedFor": zod.string().date(),
  "sourceAccountInstitutionName": zod.string().nullish(),
  "sourceAccountMask": zod.string().nullish()
})
export const listSkippedDepositsResponse = zod.array(listSkippedDepositsResponseItem)

/**
 * **Required Permission(s):** ORG_FUNDING_CREATE
 */
export const restoreSkippedDepositParams = zod.object({
  "id": zod.string().uuid()
})

/**
 * **Required Permission(s):** ORG_FUNDING_GET
 */
export const getFundingStrategyResponse = zod.object({
  "recurring": zod.object({
  "amount": zod.number(),
  "recurrence": zod.object({
  "frequency": zod.enum(['Daily', 'Weekly', 'Monthly']),
  "interval": zod.number(),
  "startDate": zod.string().date(),
  "releaseTimeOfDay": zod.enum(['BeginningOfDay', 'EndOfDay']),
  "daysOfWeek": zod.array(zod.enum(['Sunday', 'Monday', 'Tuesday', 'Wednesday', 'Thursday', 'Friday', 'Saturday'])),
  "daysOfMonth": zod.array(zod.number())
}),
  "scheduledAhead": zod.number()
}).optional(),
  "justInTime": zod.object({
  "maximumDeposit": zod.number()
}).optional()
})

/**
 * **Required Permission(s):** ORG_FUNDING_CREATE
 */
export const setFundingStrategyBody = zod.object({
  "recurring": zod.object({
  "amount": zod.number(),
  "recurrence": zod.object({
  "frequency": zod.enum(['Daily', 'Weekly', 'Monthly']),
  "interval": zod.number(),
  "startDate": zod.string().date(),
  "releaseTimeOfDay": zod.enum(['BeginningOfDay', 'EndOfDay']),
  "daysOfWeek": zod.array(zod.enum(['Sunday', 'Monday', 'Tuesday', 'Wednesday', 'Thursday', 'Friday', 'Saturday'])),
  "daysOfMonth": zod.array(zod.number())
}),
  "scheduledAhead": zod.number()
}).optional(),
  "justInTime": zod.object({
  "maximumDeposit": zod.number()
}).optional()
})

export const setFundingStrategyResponse = zod.object({
  "recurring": zod.object({
  "amount": zod.number(),
  "recurrence": zod.object({
  "frequency": zod.enum(['Daily', 'Weekly', 'Monthly']),
  "interval": zod.number(),
  "startDate": zod.string().date(),
  "releaseTimeOfDay": zod.enum(['BeginningOfDay', 'EndOfDay']),
  "daysOfWeek": zod.array(zod.enum(['Sunday', 'Monday', 'Tuesday', 'Wednesday', 'Thursday', 'Friday', 'Saturday'])),
  "daysOfMonth": zod.array(zod.number())
}),
  "scheduledAhead": zod.number()
}).optional(),
  "justInTime": zod.object({
  "maximumDeposit": zod.number()
}).optional()
})

/**
 * **Required Permission(s):** ORG_FUNDING_GET
 */
export const previewRecurringDepositsBody = zod.object({
  "recurrence": zod.object({
  "frequency": zod.enum(['Daily', 'Weekly', 'Monthly']),
  "interval": zod.number(),
  "startDate": zod.string().date(),
  "releaseTimeOfDay": zod.enum(['BeginningOfDay', 'EndOfDay']),
  "daysOfWeek": zod.array(zod.enum(['Sunday', 'Monday', 'Tuesday', 'Wednesday', 'Thursday', 'Friday', 'Saturday'])),
  "daysOfMonth": zod.array(zod.number())
}),
  "from": zod.string().date(),
  "to": zod.string().date()
})

export const previewRecurringDepositsResponse = zod.object({
  "occurrenceDays": zod.array(zod.string().date())
})

